<template>
  <div>
    excel-upload
  </div>
</template>

<script>
export default {
  name: "ExcelUpload"
}
</script>

<style scoped>

</style>
